import { template as template_9b9a44b32828431bb2f1c919dd9a9c07 } from "@ember/template-compiler";
import { hash } from '@ember/helper';
import Link from 'eflex/components/link';
const Tab = template_9b9a44b32828431bb2f1c919dd9a9c07(`
<li class="eflex-tab nav-item" ...attributes>
  <Link
    @route={{@route}}
    class="nav-link {{if @disabled "disabled"}}"
  >
    {{yield}}
  </Link>
</li>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_9b9a44b32828431bb2f1c919dd9a9c07(`
<ul class="nav eflex-tabs eflex-navigate-tabs px-3 pt-2" ...attributes>
  {{yield (hash tab=Tab)}}
</ul>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
